import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { deepCopy } from '@utils/utility';

import AddToCart from '../SlicingPage/AddToCart';
import ProductAddedToCardModel from './model/ProductAddedToCartModel';
import ProductAddedToCartShimmer from './ProductAddedToCartShimmer';

const ProductAddedToCart = ({ fields }) => {
  const [inputData, setInputData] = useState(null);

  useEffect(() => {
    const productAddedToCardModel = new ProductAddedToCardModel();

    setInputData(productAddedToCardModel.getData(deepCopy(fields || {})));
  }, []);

  return inputData ? <AddToCart dataFromLayout={inputData} /> : <ProductAddedToCartShimmer />;
};

ProductAddedToCart.propTypes = {
  fields: PropTypes.object,
  cartValue: PropTypes.object
};

export default ProductAddedToCart;
